// // Context/BrandContext.js
// import { createContext, useContext, useState, useEffect } from "react";
// import { getLocalStorageItem } from "../Utils/Index";
// import { getBrand } from "../ApiService/Apis/Items/Item";
// // import { getBrand } from "../ApiService/Apis/Items/Item";

// const BrandContext = createContext();

// export const BrandProvider = ({ children }) => {
//   const [brand, setBrand] = useState(null);

//   const FetchBrandDetails = () => {
//     const restaurantId =
//       getLocalStorageItem("userDetail")?.restaurantId ||
//       getLocalStorageItem("restaurantId");

//     if (!restaurantId) {
//       console.log("Restaurant ID not found. Skipping branding API.");
//       return;
//     }

//     getBrand(restaurantId)
//       .then((response) => {
//         if (response.status && response.data) {
//           console.log(response);
//         }
//       })
//       .catch(console.error);
//   };


//   useEffect(() => {
//     if (brand?.theme_color) {
//       document.documentElement.style.setProperty("--brand-color", brand.theme_color);
//     }
//     if (brand?.text_color) {
//       document.documentElement.style.setProperty("--text-color", brand.text_color);
//     }
//     if (brand?.bg_color1) {
//       document.documentElement.style.setProperty("--bg-color1", brand.bg_color1);
//     }
//     if (brand?.bg_color2) {
//       document.documentElement.style.setProperty("--bg-color2", brand.bg_color2);
//     }
//     if (brand?.bg_color3) {
//       document.documentElement.style.setProperty("--bg-color3", brand.bg_color3);
//     }
//   }, [brand]);

//   useEffect(() => {
//     if (brand?.title) {
//       document.title = brand.title; // ✅ Change tab title
//     }
//   }, [brand]);
//   useEffect(() => {
//     if (getLocalStorageItem("access_token")) {
//       FetchBrandDetails();
//     }
//   }, []);

//   return (
//     <BrandContext.Provider value={brand}>
//       {children}
//     </BrandContext.Provider>
//   );
// };

// // custom hook for easy access
// export const useBrand = () => useContext(BrandContext);

import { createContext, useContext, useState, useEffect } from "react";
import { getLocalStorageItem } from "../Utils/Index";
import { getBrand } from "../ApiService/Apis/Items/Item";

const BrandContext = createContext();

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(null);

  const FetchBrandDetails = async () => {
    try {
      const restaurantId =
        getLocalStorageItem("userDetail")?.restaurantId ||
        getLocalStorageItem("restaurantId");

      if (!restaurantId) {
        console.log("Restaurant ID not found");
        return;
      }

      const response = await getBrand(restaurantId);

      console.log("Brand API Response:", response);

      if (response?.status === "success" && response?.data) {
        setBrand(response.data); // ⭐⭐⭐ MOST IMPORTANT
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchBrandDetails();
  }, []);

  useEffect(() => {
    if (!brand) return;

    document.documentElement.style.setProperty(
      "--brand-color",
      brand.theme_color || "#22c55e"
    );

    document.documentElement.style.setProperty(
      "--text-color",
      brand.text_color || "#000"
    );

    document.documentElement.style.setProperty(
      "--bg-color1",
      brand.bg_color1 || "#fff"
    );

    document.documentElement.style.setProperty(
      "--bg-color2",
      brand.bg_color2 || "#f5f5f5"
    );

    document.documentElement.style.setProperty(
      "--bg-color3",
      brand.bg_color3 || "#e8e8e8"
    );

    document.title = brand.title || "Restaurant";
  }, [brand]);

  return (
    <BrandContext.Provider
      value={{
        brand,
        FetchBrandDetails,
      }}
    >
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => useContext(BrandContext);
